module.exports = __webpack_public_path__ + "img/contact-logo.d7cf8e71.png";